/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type useNodesCountQueryVariables = {
    includeProvider?: boolean | null | undefined;
    includeRenderingProvider?: boolean | null | undefined;
    includeReferringProvider?: boolean | null | undefined;
    includeFacility?: boolean | null | undefined;
    includeCustomAction?: boolean | null | undefined;
    includeApptType?: boolean | null | undefined;
    includeCCDAForms?: boolean | null | undefined;
    includeForms?: boolean | null | undefined;
    includeSchedulingPlus?: boolean | null | undefined;
    includeFormName?: boolean | null | undefined;
    includeInsurance?: boolean | null | undefined;
    includeGroup?: boolean | null | undefined;
    includeSender?: boolean | null | undefined;
    includeApprover?: boolean | null | undefined;
    includeSchedulerProvider?: boolean | null | undefined;
    includeTrueTimeProvider?: boolean | null | undefined;
};
export type useNodesCountQueryResponse = {
    readonly provider?: number | null | undefined;
    readonly providers?: number | null | undefined;
    readonly renderingProvider?: number | null | undefined;
    readonly referringProvider?: number | null | undefined;
    readonly facility?: number | null | undefined;
    readonly customAction?: number | null | undefined;
    readonly apptType?: number | null | undefined;
    readonly forms?: number | null | undefined;
    readonly ccdaForms?: number | null | undefined;
    readonly schedulingPlus?: number | null | undefined;
    readonly formName?: number | null | undefined;
    readonly insurance?: number | null | undefined;
    readonly group?: number | null | undefined;
    readonly sender?: number | null | undefined;
    readonly approver?: number | null | undefined;
    readonly schedulerProvider?: number | null | undefined;
    readonly trueTimeProvider?: number | null | undefined;
};
export type useNodesCountQuery = {
    readonly response: useNodesCountQueryResponse;
    readonly variables: useNodesCountQueryVariables;
};



/*
query useNodesCountQuery(
  $includeProvider: Boolean = false
  $includeRenderingProvider: Boolean = false
  $includeReferringProvider: Boolean = false
  $includeFacility: Boolean = false
  $includeCustomAction: Boolean = false
  $includeApptType: Boolean = false
  $includeCCDAForms: Boolean = false
  $includeForms: Boolean = false
  $includeSchedulingPlus: Boolean = false
  $includeFormName: Boolean = false
  $includeInsurance: Boolean = false
  $includeGroup: Boolean = false
  $includeSender: Boolean = false
  $includeApprover: Boolean = false
  $includeSchedulerProvider: Boolean = false
  $includeTrueTimeProvider: Boolean = false
) {
  provider: providerCount(filter: {visible: true, schedulable: true, isReferringProvider: false, type: doctor}) @include(if: $includeProvider)
  providers: providerCount(filter: {visible: true, type: doctor}) @include(if: $includeProvider)
  renderingProvider: providerCount(filter: {visible: true, isReferringProvider: false, isRenderingProvider: true, type: doctor}) @include(if: $includeRenderingProvider)
  referringProvider: providerCount(filter: {visible: true, isReferringProvider: true, isRenderingProvider: false, type: doctor}) @include(if: $includeReferringProvider)
  facility: facilityCount(filter: {visible: true}) @include(if: $includeFacility)
  customAction: followupCount(filter: {enabled: true}) @include(if: $includeCustomAction)
  apptType: appointmentTypeCount(filter: {visible: true}) @include(if: $includeApptType)
  forms: patientFormTemplateCount(filter: {type: intake}) @include(if: $includeForms)
  ccdaForms: patientFormTemplateCount(filter: {type: ccda}) @include(if: $includeCCDAForms)
  schedulingPlus: patientFormTemplateCount(filter: {type: preQualification}) @include(if: $includeSchedulingPlus)
  formName: patientFormTemplateCount @include(if: $includeFormName)
  insurance: insuranceUniquePlanNamesCount @include(if: $includeInsurance)
  group: groupCount(filter: {type: user}) @include(if: $includeGroup)
  sender: userCount(filter: {type: staff, _operators: {name: {ne: null}}}) @include(if: $includeSender)
  approver: userCount(filter: {type: staff, _operators: {name: {ne: null}, roles: {in: ["manager", "admin"]}}}) @include(if: $includeApprover)
  schedulerProvider: providerCount(filter: {visible: true, schedulable: true, isRenderingProvider: true, type: doctor}) @include(if: $includeSchedulerProvider)
  trueTimeProvider: providerCount(filter: {visible: true, schedulable: true, isRenderingProvider: true, isReferringProvider: false, type: doctor}) @include(if: $includeTrueTimeProvider)
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeApprover"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeApptType"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCCDAForms"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCustomAction"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFacility"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFormName"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeForms"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeGroup"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeInsurance"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeProvider"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReferringProvider"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRenderingProvider"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSchedulerProvider"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSchedulingPlus"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSender"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeTrueTimeProvider"
},
v16 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "visible": true
    }
  }
],
v17 = {
  "ne": null
},
v18 = [
  {
    "condition": "includeProvider",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "provider",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "isReferringProvider": false,
              "schedulable": true,
              "type": "doctor",
              "visible": true
            }
          }
        ],
        "kind": "ScalarField",
        "name": "providerCount",
        "storageKey": "providerCount(filter:{\"isReferringProvider\":false,\"schedulable\":true,\"type\":\"doctor\",\"visible\":true})"
      },
      {
        "alias": "providers",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "type": "doctor",
              "visible": true
            }
          }
        ],
        "kind": "ScalarField",
        "name": "providerCount",
        "storageKey": "providerCount(filter:{\"type\":\"doctor\",\"visible\":true})"
      }
    ]
  },
  {
    "condition": "includeRenderingProvider",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "renderingProvider",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "isReferringProvider": false,
              "isRenderingProvider": true,
              "type": "doctor",
              "visible": true
            }
          }
        ],
        "kind": "ScalarField",
        "name": "providerCount",
        "storageKey": "providerCount(filter:{\"isReferringProvider\":false,\"isRenderingProvider\":true,\"type\":\"doctor\",\"visible\":true})"
      }
    ]
  },
  {
    "condition": "includeReferringProvider",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "referringProvider",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "isReferringProvider": true,
              "isRenderingProvider": false,
              "type": "doctor",
              "visible": true
            }
          }
        ],
        "kind": "ScalarField",
        "name": "providerCount",
        "storageKey": "providerCount(filter:{\"isReferringProvider\":true,\"isRenderingProvider\":false,\"type\":\"doctor\",\"visible\":true})"
      }
    ]
  },
  {
    "condition": "includeFacility",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "facility",
        "args": (v16/*: any*/),
        "kind": "ScalarField",
        "name": "facilityCount",
        "storageKey": "facilityCount(filter:{\"visible\":true})"
      }
    ]
  },
  {
    "condition": "includeCustomAction",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "customAction",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "enabled": true
            }
          }
        ],
        "kind": "ScalarField",
        "name": "followupCount",
        "storageKey": "followupCount(filter:{\"enabled\":true})"
      }
    ]
  },
  {
    "condition": "includeApptType",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "apptType",
        "args": (v16/*: any*/),
        "kind": "ScalarField",
        "name": "appointmentTypeCount",
        "storageKey": "appointmentTypeCount(filter:{\"visible\":true})"
      }
    ]
  },
  {
    "condition": "includeForms",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "forms",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "type": "intake"
            }
          }
        ],
        "kind": "ScalarField",
        "name": "patientFormTemplateCount",
        "storageKey": "patientFormTemplateCount(filter:{\"type\":\"intake\"})"
      }
    ]
  },
  {
    "condition": "includeCCDAForms",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "ccdaForms",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "type": "ccda"
            }
          }
        ],
        "kind": "ScalarField",
        "name": "patientFormTemplateCount",
        "storageKey": "patientFormTemplateCount(filter:{\"type\":\"ccda\"})"
      }
    ]
  },
  {
    "condition": "includeSchedulingPlus",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "schedulingPlus",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "type": "preQualification"
            }
          }
        ],
        "kind": "ScalarField",
        "name": "patientFormTemplateCount",
        "storageKey": "patientFormTemplateCount(filter:{\"type\":\"preQualification\"})"
      }
    ]
  },
  {
    "condition": "includeFormName",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "formName",
        "args": null,
        "kind": "ScalarField",
        "name": "patientFormTemplateCount",
        "storageKey": null
      }
    ]
  },
  {
    "condition": "includeInsurance",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "insurance",
        "args": null,
        "kind": "ScalarField",
        "name": "insuranceUniquePlanNamesCount",
        "storageKey": null
      }
    ]
  },
  {
    "condition": "includeGroup",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "group",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "type": "user"
            }
          }
        ],
        "kind": "ScalarField",
        "name": "groupCount",
        "storageKey": "groupCount(filter:{\"type\":\"user\"})"
      }
    ]
  },
  {
    "condition": "includeSender",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "sender",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "_operators": {
                "name": (v17/*: any*/)
              },
              "type": "staff"
            }
          }
        ],
        "kind": "ScalarField",
        "name": "userCount",
        "storageKey": "userCount(filter:{\"_operators\":{\"name\":{\"ne\":null}},\"type\":\"staff\"})"
      }
    ]
  },
  {
    "condition": "includeApprover",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "approver",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "_operators": {
                "name": (v17/*: any*/),
                "roles": {
                  "in": [
                    "manager",
                    "admin"
                  ]
                }
              },
              "type": "staff"
            }
          }
        ],
        "kind": "ScalarField",
        "name": "userCount",
        "storageKey": "userCount(filter:{\"_operators\":{\"name\":{\"ne\":null},\"roles\":{\"in\":[\"manager\",\"admin\"]}},\"type\":\"staff\"})"
      }
    ]
  },
  {
    "condition": "includeSchedulerProvider",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "schedulerProvider",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "isRenderingProvider": true,
              "schedulable": true,
              "type": "doctor",
              "visible": true
            }
          }
        ],
        "kind": "ScalarField",
        "name": "providerCount",
        "storageKey": "providerCount(filter:{\"isRenderingProvider\":true,\"schedulable\":true,\"type\":\"doctor\",\"visible\":true})"
      }
    ]
  },
  {
    "condition": "includeTrueTimeProvider",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "trueTimeProvider",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "isReferringProvider": false,
              "isRenderingProvider": true,
              "schedulable": true,
              "type": "doctor",
              "visible": true
            }
          }
        ],
        "kind": "ScalarField",
        "name": "providerCount",
        "storageKey": "providerCount(filter:{\"isReferringProvider\":false,\"isRenderingProvider\":true,\"schedulable\":true,\"type\":\"doctor\",\"visible\":true})"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useNodesCountQuery",
    "selections": (v18/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v13/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v14/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Operation",
    "name": "useNodesCountQuery",
    "selections": (v18/*: any*/)
  },
  "params": {
    "cacheID": "a422ea7f5c357404fb5792ccf272f910",
    "id": null,
    "metadata": {},
    "name": "useNodesCountQuery",
    "operationKind": "query",
    "text": "query useNodesCountQuery(\n  $includeProvider: Boolean = false\n  $includeRenderingProvider: Boolean = false\n  $includeReferringProvider: Boolean = false\n  $includeFacility: Boolean = false\n  $includeCustomAction: Boolean = false\n  $includeApptType: Boolean = false\n  $includeCCDAForms: Boolean = false\n  $includeForms: Boolean = false\n  $includeSchedulingPlus: Boolean = false\n  $includeFormName: Boolean = false\n  $includeInsurance: Boolean = false\n  $includeGroup: Boolean = false\n  $includeSender: Boolean = false\n  $includeApprover: Boolean = false\n  $includeSchedulerProvider: Boolean = false\n  $includeTrueTimeProvider: Boolean = false\n) {\n  provider: providerCount(filter: {visible: true, schedulable: true, isReferringProvider: false, type: doctor}) @include(if: $includeProvider)\n  providers: providerCount(filter: {visible: true, type: doctor}) @include(if: $includeProvider)\n  renderingProvider: providerCount(filter: {visible: true, isReferringProvider: false, isRenderingProvider: true, type: doctor}) @include(if: $includeRenderingProvider)\n  referringProvider: providerCount(filter: {visible: true, isReferringProvider: true, isRenderingProvider: false, type: doctor}) @include(if: $includeReferringProvider)\n  facility: facilityCount(filter: {visible: true}) @include(if: $includeFacility)\n  customAction: followupCount(filter: {enabled: true}) @include(if: $includeCustomAction)\n  apptType: appointmentTypeCount(filter: {visible: true}) @include(if: $includeApptType)\n  forms: patientFormTemplateCount(filter: {type: intake}) @include(if: $includeForms)\n  ccdaForms: patientFormTemplateCount(filter: {type: ccda}) @include(if: $includeCCDAForms)\n  schedulingPlus: patientFormTemplateCount(filter: {type: preQualification}) @include(if: $includeSchedulingPlus)\n  formName: patientFormTemplateCount @include(if: $includeFormName)\n  insurance: insuranceUniquePlanNamesCount @include(if: $includeInsurance)\n  group: groupCount(filter: {type: user}) @include(if: $includeGroup)\n  sender: userCount(filter: {type: staff, _operators: {name: {ne: null}}}) @include(if: $includeSender)\n  approver: userCount(filter: {type: staff, _operators: {name: {ne: null}, roles: {in: [\"manager\", \"admin\"]}}}) @include(if: $includeApprover)\n  schedulerProvider: providerCount(filter: {visible: true, schedulable: true, isRenderingProvider: true, type: doctor}) @include(if: $includeSchedulerProvider)\n  trueTimeProvider: providerCount(filter: {visible: true, schedulable: true, isRenderingProvider: true, isReferringProvider: false, type: doctor}) @include(if: $includeTrueTimeProvider)\n}\n"
  }
};
})();
(node as any).hash = 'b8850a5a2a14638e392965f728eb0bdd';
export default node;
